import { useSelector } from 'react-redux';
import { Box, Text } from '@chakra-ui/react';
import { ApplicationState } from '../../../../../store';
import { CustomHeading, Link } from 'shared-components';
import Field from '../../../../Field/Field';
import { PrevNextButtons } from '../../../../PrevNextButtons';

import { useNavigate } from 'react-router-dom';
import ApplicantHeader from '../../../../../components/molecules/applicantHeader';
import { getApplicationData } from '../helpers';
import { useTaskNavigation } from '@/hooks/useTaskNavigation';

export default function PrivacyPolicy() {
  const { application } = useSelector((state: ApplicationState) => state.apply);
  const { applyConfig } = useSelector((state: ApplicationState) => state.applyConfig);

  const { current, initial } = getApplicationData(application);

  const { termsAndConditionsConsent, universityName } = current;
  const { termsAndConditionsConsent: initialTermsAndConditionsConsent } = initial;

  const AcceptanceText = () => (
    <Text>
      I consent to the {universityName}{' '}
      <Link href={termsAndConditionsUrl} isExternal>
        Terms and Conditions
      </Link>
      .
    </Text>
  );

  const RejectionText = () => <Text>This user has not accepted their terms and conditions.</Text>;

  const { termsAndConditionsUrl } = applyConfig;

  const navigate = useNavigate();
  const { nextRoute, previousRoute } = useTaskNavigation();
  return (
    <>
      <ApplicantHeader pageName="Application" />
      <Box>
        <CustomHeading level="h1" flexGrow={1} mb={8}>
          Terms & conditions
        </CustomHeading>

        <CustomHeading level="h2" mb={2} mt={6} fontSize="md">
          Data
        </CustomHeading>

        <Box>
          {termsAndConditionsConsent && (
            <Field
              leftLabel="Agreed to"
              value={termsAndConditionsConsent ? <AcceptanceText /> : <RejectionText />}
              originalValue={initialTermsAndConditionsConsent ? <AcceptanceText /> : <RejectionText />}
            />
          )}
        </Box>

        <Box mt={6}>
          <PrevNextButtons
            onPrevious={previousRoute ? () => navigate(previousRoute) : undefined}
            onNext={nextRoute ? () => navigate(nextRoute) : undefined}
          />
        </Box>
      </Box>
    </>
  );
}
